import {
  Box,
  Grid2,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import React from "react";
import { commonCss } from "../../../CssStyle/commonCss";
import {
  Done,
  BalanceOutlined,
  CodeOffOutlined,
  FiberManualRecord,
  HowToVote,
  InsertChart,
  PeopleAltOutlined,
  PieChartOutline,
  TaskAlt,
  WorkspacesRounded,
} from "@mui/icons-material";
// import aboutUsBg from "../../../Images/aboutUsBg.jpg";
// import sharepoint from "../../../Images/Sharepoint/Sharepoint.jpeg";
const TestAutomation = () => {
  return (
    <Grid2 container>
      <Grid2 container size={12} justifyContent={"center"}>
        <Grid2
          container
          size={12}
          sx={{ background: `url(/Images/aboutUsBg.jpg)`, backgroundSize: "cover" }}
          justifyContent={"center"}
        >
          <Grid2
            container
            size={{ xs: 12, md: 11, xl: 10 }}
            justifyContent={"center"}
            alignItems={"center"}
            mt={{ xs: "30%", sm: "20%", md: "15%", lg: "13%", xl: "8%" }}
            sx={{ p: "1rem", maxWidth: { xs: "auto", xl: "2000px" } }}
          >
            <Typography
              variant="h5"
              sx={{
                fontSize: { xs: "1.5rem", md: "2.5rem" },
                fontWeight: 600,
                lineHeight: "normal",
                mb: "1rem",
                color: commonCss.blue,
              }}
            >
              Quality Assurance & Test Automation Services
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: "1rem", md: "1.1rem" },
                mb: "1rem",
                textAlign: "center",
                color: commonCss.darkGray,
              }}
            >
              We specialize in delivering reliable and scalable software testing solutions tailored to meet your business needs. Our expert QA team ensures your applications are robust, secure, and bug-free — providing a seamless experience for your users.
            </Typography>
          </Grid2>
        </Grid2>
        <Grid2
          container
          size={12}
          // sx={{ background: `url(${aboutUsBg})`, backgroundSize: "cover" }}
          justifyContent={"center"}
        >
          <Grid2
            size={{ xs: 12, md: 11, xl: 10 }}
            sx={{
              p: { xs: "1rem", md: "3rem" },
              maxWidth: { xs: "auto", xl: "2000px" },
            }}
          >
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                gap: "2rem",
              }}
            >
              <Box
                component={"img"}
                src={"/Images/TestingAutomation/testautomation.png"}
                alt="Test Automation"
                sx={{
                  borderRadius: "15px",
                  width: "100%",
                  height: { xs: "50vh", md: "70vh" },
                  objectFit: "cover",
                }}
              />
            </Box>
          </Grid2>
        </Grid2>
        <Grid2
          container
          size={12}
          // sx={{ background: `url(${aboutUsBg})`, backgroundSize: "cover" }}
          justifyContent={"center"}
        >
          <Grid2
            container
            size={{ xs: 12, md: 11, xl: 10 }}
            justifyContent={"center"}
            spacing={{ xs: "1rem", md: "2rem" }}
            sx={{
              p: { xs: "1rem", md: "3rem" },
              maxWidth: { xs: "auto", xl: "2000px" },
            }}
          >
           
            <Grid2 size={{ xs: 12, md: 6 }}>
              <Box
                sx={{
                  display: "flex",
                  gap: { xs: "1rem", md: "2rem" },
                  width: "100%",
                }}
              >
                <TaskAlt
                  sx={{ color: commonCss.orange, fontSize: "2rem", mt: 1 }}
                />
                <Box>
                  <Typography
                    variant="h4"
                    sx={{
                      fontSize: { xs: "1.5rem", md: "2rem" },
                      fontWeight: 600,
                      lineHeight: "normal",
                    }}
                  >
                    Performance Testing
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: { xs: "1rem", md: "1.1rem" },
                      fontSize: { xs: "0.8rem", md: "1rem" },
                      mt: "1rem",
                      color: commonCss.darkGray,
                    }}
                  >
                    Performance bottlenecks can make or break the user experience. We simulate real-world traffic scenarios to ensure your application can handle peak loads and scale confidently.
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "1.1rem",
                      fontWeight: 450,
                      fontFamily: "inherit",
                      mt: 2,
                      color: commonCss.darkGray,
                    }}
                  >
                   Our performance testing services help you:
                  </Typography>
                  <List
                    sx={{
                      "& .MuiListItemText-primary": {
                        fontFamily: "Roboto, sans-serif",
                        fontSize: "1rem",
                        fontWeight: "normal",
                        color: commonCss.darkGray,
                      },
                      display: "flex",
                      columnGap: "1rem",
                      rowGap: "0.5rem",
                      flexWrap: "wrap",
                      width: "100%",
                      //    mt:"1rem"
                    }}
                  >
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>Assess system behavior under load</ListItemText>
                    </ListItem>

                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>Identify scalability issues</ListItemText>
                    </ListItem>

                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                      Optimize response time and stability
                      </ListItemText>
                    </ListItem>
                  </List>
                </Box>
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 12, md: 6 }}>
              <Box
                sx={{
                  display: "flex",
                  gap: { xs: "1rem", md: "2rem" },
                  width: "100%",
                }}
              >
                <TaskAlt
                  sx={{ color: commonCss.orange, fontSize: "2rem", mt: 1 }}
                />
                <Box>
                  <Typography
                    variant="h4"
                    sx={{
                      fontSize: { xs: "1.5rem", md: "2rem" },
                      fontWeight: 600,
                      lineHeight: "normal",
                    }}
                  >
                    Why Choose Us?
                  </Typography>

                  <List
                    sx={{
                      "& .MuiListItemText-primary": {
                        fontFamily: "Roboto, sans-serif",
                        fontSize: "1rem",
                        fontWeight: "normal",
                        color: commonCss.darkGray,
                      },
                      display: "flex",
                      columnGap: "1rem",
                      rowGap: "0.5rem",
                      flexWrap: "wrap",
                      width: "100%",
                      //    mt:"1rem"
                    }}
                  >
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>Expert QA Engineers with deep tool proficiency</ListItemText>
                    </ListItem>

                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>End-to-End Testing Coverage across all stages of development</ListItemText>
                    </ListItem>

                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>Custom Test Strategies tailored to your business goals</ListItemText>
                    </ListItem>
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>Agile & DevOps Friendly – CI/CD integrated</ListItemText>
                    </ListItem>
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                      Clear Reporting with actionable insights
                      </ListItemText>
                    </ListItem>
                    
                  </List>
                </Box>
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 12, md: 6 }}>
              <Box
                sx={{
                  display: "flex",
                  gap: { xs: "1rem", md: "2rem" },
                  width: "100%",
                }}
              >
                <TaskAlt
                  sx={{ color: commonCss.orange, fontSize: "2rem", mt: 1 }}
                />
                <Box>
                  <Typography
                    variant="h4"
                    sx={{
                      fontSize: { xs: "1.5rem", md: "2rem" },
                      fontWeight: 600,
                      lineHeight: "normal",
                    }}
                  >
                    Automation Testing Services
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: { xs: "1rem", md: "1.1rem" },
                      fontSize: { xs: "0.8rem", md: "1rem" },
                      mt: "1rem",
                      color: commonCss.darkGray,
                    }}
                  >
                    Speed up your release cycle without compromising on quality. Our experienced automation engineers use industry-leading tools to design, develop, and maintain test automation frameworks that drive efficiency and reduce manual effort.
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "1.1rem",
                      fontWeight: 450,
                      fontFamily: "inherit",
                      mt: 2,
                      color: commonCss.darkGray,
                    }}
                  >
                    We work with the most powerful test automation tools:
                  </Typography>
                  <List
                    sx={{
                      "& .MuiListItemText-primary": {
                        fontFamily: "Roboto, sans-serif",
                        fontSize: "1rem",
                        fontWeight: "normal",
                        color: commonCss.darkGray,
                      },
                      display: "flex",
                      columnGap: "1rem",
                      rowGap: "0.5rem",
                      flexWrap: "wrap",
                      width: "100%",
                      //    mt:"1rem"
                    }}
                  >
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                      Selenium – Flexible and widely-used for cross-browser automation.
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>Playwright – Modern end-to-end testing with fast execution.</ListItemText>
                    </ListItem>

                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                      Cypress – Developer-friendly tool for modern web apps.
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                      Katalon Studio – Simplified automation for web, API, and mobile testing.
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                      TestingWhiz – Codeless automation testing tool for quick deployment.
                      </ListItemText>
                    </ListItem>
                  </List>
                  <Typography
                    sx={{
                      fontSize: { xs: "1rem", md: "1.1rem" },
                      fontSize: { xs: "0.8rem", md: "1rem" },
                      mt: "1rem",
                      color: commonCss.darkGray,
                    }}
                  >
                   Whether you're building a web app, mobile platform, or enterprise software, we tailor our test strategies to align with your development process and goals.
                  </Typography>
                </Box>
              </Box>
            </Grid2>
          </Grid2>
        </Grid2>
      </Grid2>
    </Grid2>
  );
};

export default TestAutomation;
